<template>
  <div>
    <span :class="{'selected': item.value === value}" class="item"
          @click="clickItem(item)"
        v-for="(item,idx) in options"
        :key="'rb-'+idx" v-if="item.selected">{{ item.label }}</span>
  </div>
</template>

<script>
  export default {
    name: "LpRadioButton",
    props: {
      options: {
        type: Array,
        required: true
      },
      value: {
        required: true
      }
    },
    methods: {
      clickItem(item) {
        this.$emit('update:value', item.value);
      }
    }

  }
</script>

<style lang="stylus" scoped>
  @import '~assets/css/lp_main'
  .item
    border 1px solid #dfdfdf
    color #989898
    display inline-block
    padding 4px 16px
    border-radius 3px
    margin-right 8px
    font-size 14px
    cursor pointer

  .selected
    color $primary
    border 1px solid $primary

</style>
